import React, { useState } from 'react';
import './ChatWindow.css';
import avatar from '../../contact-custom.png'; // Adjust path
import sentSound from '../../custom service message.mp3';

const ChatWindow = ({ onClose }) => {
  const audio = new Audio(sentSound);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [showGift, setShowGift] = useState(false);
  const [giftAmount, setGiftAmount] = useState(1);
  // Removed stars and thankYou states as per new modal design

  const sendMessage = async () => {
    if (!input.trim()) return;

    audio.play(); // 👈 play sound immediately on send

    const userMessage = { sender: 'user', text: input };
    setMessages([...messages, userMessage]);
    setInput('');

    try {
      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: input })
      });

      const data = await res.json();
      const botMessage = { sender: 'bot', text: data.reply };
      setMessages(prev => [...prev, botMessage]);

    } catch (err) {
      setMessages(prev => [...prev, { sender: 'bot', text: 'Sorry, something went wrong.' }]);
    }
  };

  const handleSendGift = () => {
    // Save to DB or backend
    setMessages(prev => [...prev, { sender: 'user', text: `✨ Sent ${giftAmount} stars to Sophia!` }]);
    setShowGift(false);
  };


  return (
    <div className="chat-window">
      <div className="chat-header">
        <img src={avatar} alt="Agent Avatar" className="agent-avatar" />
        <div className="agent-info">
          <h4>Sophia</h4>
          <p>Customer Support</p>
        </div>
        <button className="gift-btn" onClick={() => setShowGift(true)}>🎁</button>
        <button className="close-btn" onClick={onClose}>✖</button>
      </div>

      <div className="chat-messages">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>{msg.text}</div>
        ))}
      </div>

      <div className="chat-input">
        <label htmlFor="chatInput" style={{ marginRight: '8px', color: '#333', fontWeight: 'bold' }}>Type your message:</label>
        <input
          id="chatInput"
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Ask Sophia anything..."
        />
        <button onClick={sendMessage}>Send</button>
      </div>

      {showGift && (
        <div className="gift-modal" onClick={() => setShowGift(false)}>
          <div className="gift-content" onClick={e => e.stopPropagation()}>
            <h4>🎁 Send Stars to Sophia</h4>
            <input
              type="number"
              min="1"
              max="100"
              value={giftAmount}
              onChange={(e) => setGiftAmount(e.target.value)}
              placeholder="Enter number of stars"
            />
            <button onClick={handleSendGift}>Send 🌟</button>
            <button className="close-gift" onClick={() => setShowGift(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
